import * as React from "react";
import { Alert } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { BasePathContext } from "../../reactContexts/basePathContext";
import { Mk8sCluster } from "../../schema/types/mk8s/entity/mk8s";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { LogsPage } from "../../newcomponents/logs";

interface Props {
  mk8s: Mk8sCluster;
}

export const Mk8sLogs: React.FC<Props> = ({ mk8s }) => {
  const org = useAppSelector(selectOrg);
  const logsEndpoint = useAppSelector((state) => state.discovery.endpoints.logs);
  const grafanaEndpoint = useAppSelector((state) => state.discovery.endpoints.grafana);

  const basePath = React.useContext(BasePathContext);

  const DEFAULT_LOG_QUERY = `{cluster_name="${mk8s.name}", cluster_alias="${mk8s.alias}"}`;
  const LOGS_STORAGE_KEY = `logs-${org}-${mk8s.name}-${mk8s.alias}`;

  // beforeQuery callback for addon check
  const beforeQuery = React.useCallback(() => {
    return !!mk8s.spec?.addOns?.logs;
  }, [mk8s.spec?.addOns?.logs]);

  // Early return if logs addon not enabled
  if (!mk8s.spec?.addOns?.logs) {
    return (
      <div>
        <Alert className="mb-4" message="Logs Addon is not enabled. Enable it in Add-ons, to browse logs." />
        <Link className="color-link flex items-center gap-1" to={`${basePath}/addons`}>
          <span>Go to Add-ons</span>
          <RightOutlined />
        </Link>
      </div>
    );
  }

  return (
    <LogsPage
      org={org!}
      defaultQuery={DEFAULT_LOG_QUERY}
      storageKey={LOGS_STORAGE_KEY}
      fileNamePrefix={mk8s.name}
      logsEndpoint={logsEndpoint}
      grafanaEndpoint={grafanaEndpoint.replace("{org}", org!)}
      beforeQuery={beforeQuery}
    />
  );
};
